import { cloneDeep, isArray, isObject } from "lodash";
import { safelyParseJSON } from "./common";

/**
 * Function used to parse all the JSON data for submitted food mood logs
 */
export const transformFMJData = (data) => {
  try {
    const parseFMJRow = (row) => {
      let rowClone = cloneDeep(row);
      if(rowClone.additional_notes) {
        rowClone.additional_notes = row.additional_notes && JSON.parse(row.additional_notes);
      }
      if(rowClone.food_served) {
        rowClone.food_served = row.food_served && JSON.parse(row.food_served);
      }
      return rowClone;
    }

    if(!isArray(data) && isObject(data)) {

      return parseFMJRow(data);

    } else if(isArray(data)){

      return data.map(row => {
        return parseFMJRow(row);
      });

    }
  } catch(err) {
    console.log("Error transforming food mood logs data", err);
    return data;
  }
}

/**
 * Function used to format the todo response
 */

export function formatTodoResponse(todoDetails) {
  try {
    if(!todoDetails || !todoDetails?.length) {
      return;
    }
    return todoDetails.map(page => {
      page.questions = page.questions.map(question => {
        question.answer = JSON.parse(question.client_response)?.response;

        const questionMeta = safelyParseJSON(question?.question_meta);
    
        question.question_type_label = questionMeta?.question_type_label || question?.question_type_label;
        question.question_type = questionMeta?.question_type || question?.question_type;
        question.other_column_data = questionMeta?.other_column_data || question?.other_column_data;
        question.question = questionMeta?.question || question?.question;

        return question;
      })
      return page;
    })
  } catch(err) {
    console.log("Error formatting todo response", err);
    return todoDetails;
  }
}

/**
 * Function used to format the todo list
 */
export function formatTodoList(todoList) {
  try {
    if(!todoList || !todoList?.length) {
      throw new Error("No data to format");
    }
    return todoList.map(todo => {
      todo.form_name = todo?.form_meta?.form_name || todo.form_name;
      todo.form_desc = todo?.form_meta?.form_desc || todo.form_desc;
      return todo;
    })
  } catch(err) {
    console.error("Error formatting todo list", err);
    return todoList;
  }
}